import Vue from 'vue'
import VueRouter from 'vue-router'

import middlewarePipeline from "./middleware/middlewarePipeline"
import guest from './middleware/guest'
import auth from './middleware/auth'
import mobileBiometric from './middleware/mobileBiometric'
import operator from "@/router/middleware/operator"
import user from "@/router/middleware/user"
import mobileApp from "@/router/middleware/mobileApp"

Vue.use(VueRouter)

export const routes = [
  {
    path: '/',
    name: 'dashboard',
    component: () => import('@/pages/LkPage'),
    meta: {
      middleware: [
        auth,
        user,
        mobileBiometric
      ],
      layout: 'AppLayoutMain'
    }
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/pages/LoginPage'),
    meta: {
      middleware: [
        guest
      ]
    }
  },
  {
    path: '/auth/online-return',
    name: 'OnlineReturn',
    component: () => import('@/pages/OnlineReturn'),
  },
  {
    path: '/mobile-biometric',
    name: 'mobileBiometric',
    component: () => import('@/pages/MobileBiometricPage.vue'),
    meta: {
      middleware: [
        auth
      ]
    }
  },
  {
    path: '/mobile-pin-code',
    name: 'MobilePinCode',
    component: () => import('@/pages/MobilePinCodePage.vue'),
    meta: {
      middleware: [
        auth
      ]
    }
  },
  {
    path: '/email/confirm/:token',
    name: 'emailConfirm',
    component: () => import('@/pages/EmailConfirmPage'),
  },
  {
    path: '/biometry',
    name: 'biometry',
    component: () => import('@/pages/BiometryPage'),
    meta: {
      middleware: [
        guest
      ]
    }
  },
  {
    path: '/kdp',
    name: 'kdp',
    component: () => import('@/pages/KdpPage.vue'),
    meta: {
      middleware: [
        guest
      ]
    }
  },
  {
    path: '/insurance/property',
    name: 'propertyInsurance',
    component: () => import('@/pages/insurance/PropertyInsurance'),
    props: true,
    meta: {
      middleware: [
        auth,
        user
      ],
      layout: 'AppLayoutWithScrollBar'
    }
  },
  /*    {
          path: '/insurance/dtp',
          name: 'KaskoDtp',
          component: KaskoDtp,
          props: true,
          meta: {
              middleware: [
                  auth,
                  user
              ],
              layout: 'AppLayoutWithScrollBar'
          }
      },*/
  {
    path: '/pay',
    name: 'PayPage',
    component: () => import('@/pages/PayPage'),
    props: true,
    meta: {
      middleware: [
        auth
      ],
      layout: 'AppLayoutMain'
    }
  },
  {
    path: '/insurance/dsgpo',
    name: 'DSGPO',
    component: () => import('@/pages/insurance/DSGPO'),
    props: true,
    meta: {
      middleware: [
        auth,
        user
      ],
      layout: 'AppLayoutWithScrollBar'
    }
  },
  {
    path: '/insurance/ogpo',
    name: 'OGPO',
    component: () => import('@/pages/insurance/OgpoEntry'),
    props: true,
    meta: {
      middleware: [
        auth,
        user
      ],
      layout: 'AppLayoutWithScrollBar'
    }
  },
  {
    path: '/insurance/ogpo-online',
    name: 'OnlineOgpo',
    component: () => import('@/pages/OnlineOgpoHandoff'),
    meta: {
      middleware: [
        auth,
        user
      ],
      layout: 'AppLayoutMain'
    }
  },
  {
    path: '/insurance/kasko-transformer',
    name: 'KaskoTransformer',
    component: () => import('@/pages/insurance/KaskoTransformer'),
    props: true,
    meta: {
      middleware: [
        auth,
        user
      ],
      layout: 'AppLayoutWithScrollBar'
    }
  },
  {
    path: '/insurance/mst',
    name: 'MST',
    component: () => import('@/pages/insurance/MST'),
    props: true,
    meta: {
      middleware: [
        auth,
        user
      ],
      layout: 'AppLayoutWithScrollBar'
    }
  },
  {
    path: '/payment/success',
    name: 'MstPaymentSuccess',
    component: () => import('@/pages/insurance/mst/MstPaymentSuccess'),
    meta: {
      middleware: [
        auth,
        user
      ],
      layout: 'AppLayoutWithScrollBar'
    }
  },
  {
    path: '/payment/failure',
    name: 'MstPaymentFailure',
    component: () => import('@/pages/insurance/mst/MstPaymentFailure'),
    meta: {
      middleware: [
        auth,
        user
      ],
      layout: 'AppLayoutWithScrollBar'
    }
  },
  {
    path: '/insurance/ont',
    name: 'ONT',
    component: () => import('@/pages/insurance/ONT'),
    props: true,
    meta: {
      middleware: [
        auth,
        user
      ],
      layout: 'AppLayoutWithScrollBar'
    }
  },
  {
    path: '/insurance/advokat',
    name: 'ADVOKAT',
    component: () => import('@/pages/insurance/Advokat'),
    props: true,
    meta: {
      middleware: [
        auth,
        user
      ],
      layout: 'AppLayoutWithScrollBar'
    }
  },
  {
    path: '/insurance/chsi',
    name: 'CHSI',
    component: () => import('@/pages/insurance/Chsi'),
    props: true,
    meta: {
      middleware: [
        auth,
        user
      ],
      layout: 'AppLayoutWithScrollBar'
    }
  },
  {
    path: '/insurance/puk',
    name: 'PUK',
    component: () => import('@/pages/insurance/Puk'),
    props: true,
    meta: {
      middleware: [
        auth,
        user
      ],
      layout: 'AppLayoutWithScrollBar'
    }
  },
  {
    path: '/insurance/comfort',
    name: 'Comfort',
    component: () => import('@/pages/insurance/Comfort'),
    props: true,
    meta: {
      middleware: [
        auth,
        user
      ],
      layout: 'AppLayoutWithScrollBar'
    }
  },
  {
    path: '/insurance/cargo',
    name: 'Cargo',
    component: () => import('@/pages/insurance/Cargo'),
    props: true,
    meta: {
      middleware: [
        auth,
        user
      ],
      layout: 'AppLayoutWithScrollBar'
    }
  },
  {
    path: '/insurance/accident',
    name: 'ACCIDENT',
    component: () => import('@/pages/insurance/Accident.vue'),
    props: true,
    meta: {
      middleware: [
        auth,
        user
      ],
      layout: 'AppLayoutWithScrollBar'
    }
  },
  {
    path: '/insurance/accident-sport',
    name: 'ACCIDENT_SPORT',
    component: () => import('@/pages/insurance/AccidentSport.vue'),
    props: true,
    meta: {
      middleware: [
        auth,
        user
      ],
      layout: 'AppLayoutWithScrollBar'
    }
  },
  {
    path: '/insurance/opp',
    name: 'Opp',
    component: () => import('@/pages/insurance/Opp'),
    props: true,
    meta: {
      middleware: [
        auth,
        user
      ],
      layout: 'AppLayoutWithScrollBar'
    }
  },
  {
    path: '/more',
    name: 'MorePage',
    component: () => import('@/pages/mobileApp/MorePage'),
    props: true,
    meta: {
      middleware: [
        auth,
        mobileApp
      ],
      layout: 'AppLayoutMain'
    }
  },
  {
    path: '/more/about',
    name: 'AboutPage',
    component: () => import('@/pages/mobileApp/AboutPage'),
    props: true,
    meta: {
      middleware: [
        auth,
        mobileApp
      ],
      layout: 'AppLayoutWithTopNavBar'
    }
  },
  {
    path: '/europrotocol',
    name: 'EuroprotocolPage',
    component: () => import('@/pages/mobileApp/EuroprotocolPage'),
    props: true,
    meta: {
      middleware: [
        auth
        // mobileApp
      ],
      layout: 'AppLayoutEuroprotocol'
    }
  },
  {
    path: '/more/dynamic-info',
    name: 'DynamicInfoPage',
    component: () => import('@/pages/mobileApp/DynamicInfoPage'),
    props: true,
    meta: {
      middleware: [
        auth,
        mobileApp
      ],
      layout: 'AppLayoutWithTopNavBar'
    }
  },
  //operator routes
    {
        path: '/operator',
        component: {
          render: (c) => c('router-view'),
        },
        children: [
          {
            path: 'login',
            name: 'OperatorLogin',
            component: () => import('@/pages/operator/OperatorLoginPage'),
            meta: {
              middleware: [
                guest
              ],
              layout: 'AppLayoutOperatorLogin'
            }
          },
          {
            path: 'dashboard',
            name: 'OperatorDashboard',
            component: () => import('@/pages/operator/OperatorDashboard'),
            meta: {
              middleware: [
                auth,
                operator
              ],
              layout: 'AppLayoutOperator'
            }
          },
          {
            path: 'knowledgeBase',
            name: 'knowledgeBase',
            component: () => import('@/pages/knowledgeBase'),
            meta: {
              middleware: [
                auth,
                operator
              ],
              layout: 'AppLayoutOperator'
            }
          },
          {
            path: 'clients/:id',
            name: 'ClientCard',
            component: () => import('@/pages/operator/ClientCard'),
            meta: {
              middleware: [
                auth,
                operator
              ],
              layout: 'AppLayoutOperator'
            }
          },
          {
            path: 'call/history',
            name: 'AllCallHistory',
            component: () => import('@/pages/operator/AllCallHistory'),
            meta: {
              middleware: [
                auth,
                operator
              ],
              layout: 'AppLayoutOperator'
            }
          },
          {
            path: 'call/missed/report',
            name: 'MissedCallsReport',
            component: () => import('@/pages/operator/MissedCallsReport'),
            meta: {
              middleware: [
                auth,
                operator
              ],
              layout: 'AppLayoutOperator'
            }
          },
          {
            path: 'applications',
            name: 'ApplicationsPage',
            component: () => import('@/pages/operator/ApplicationsPage'),
            meta: {
              middleware: [
                auth,
                operator
              ],
              layout: 'AppLayoutOperator'
            }
          },
          {
            path: 'applications/vremenniy',
            name: 'ApplicationsPageVV',
            component: () => import('@/pages/operator/ApplicationsPageVV'),
            meta: {
              middleware: [
                auth,
                operator
              ],
              layout: 'AppLayoutOperator'
            }
          },
          {
            path: 'applications/revision',
            name: 'ApplicationsRevisionPage',
            component: () => import('@/pages/operator/ApplicationsRevisionPage.vue'),
            meta: {
              middleware: [
                auth,
                operator
              ],
              layout: 'AppLayoutOperator'
            }
          },
          {
            path: 'applications/in-progress',
            name: 'ApplicationsInProgressPage',
            component: () => import('@/pages/operator/ApplicationsInProgressPage.vue'),
            meta: {
              middleware: [
                auth,
                operator
              ],
              layout: 'AppLayoutOperator'
            }
          },
          {
            path: 'applications/completed',
            name: 'ApplicationsCompletedPage',
            component: () => import('@/pages/operator/ApplicationsCompletedPage.vue'),
            meta: {
              middleware: [
                auth,
                operator
              ],
              layout: 'AppLayoutOperator'
            }
          },
          {
            path: 'applications/search-ss',
            name: 'ApplicationsSearchSs',
            component: () => import('@/pages/operator/ApplicationsSearchSs.vue'),
            meta: {
              middleware: [
                auth,
                operator
              ],
              layout: 'AppLayoutOperator'
            }
          },
          {
            path: 'applications/avarkom-search',
            name: 'ApplicationsAvarkomSearchPage',
            component: () => import('@/pages/operator/ApplicationsAvarkomSearchPage.vue'),
            meta: {
              middleware: [
                auth,
                operator
              ],
              layout: 'AppLayoutOperator'
            }
          },
          {
            path: 'insurance-case-jobs',
            name: 'InsuranceCaseJobsStatusPage',
            component: () => import('@/pages/InsuranceCaseJobsStatusPage.vue'),
            meta: {
              middleware: [
                auth,
                operator
              ],
              layout: 'AppLayoutOperator'
            }
          },
          {
            path: 'applications/report',
            name: 'ApplicationReportPage',
            component: () => import('@/pages/operator/ApplicationReportPage'),
                meta: {
                    middleware: [
                        auth,
                        operator
                    ],
                    layout: 'AppLayoutOperator'
                }
            },
            {
                path: 'applications/:id',
                name: 'ApplicationsPageId',
            component: () => import('@/pages/operator/ApplicationsPage'),
                meta: {
                    middleware: [
                        auth,
                        operator
                    ],
                    layout: 'AppLayoutOperator'
                }
            },
            {
                path: 'purchased-policies-report',
                name: 'PurchasedPoliciesReport',
            component: () => import('@/pages/operator/PurchasedPoliciesReport'),
                meta: {
                    middleware: [
                        auth,
                        operator
                    ],
                    layout: 'AppLayoutOperator'
                }
            },
            {
              path: 'vremenniy-policies-report',
              name: 'VremenniyPoliciesReport',
            component: () => import('@/pages/operator/VremenniyPoliciesReport.vue'),
              meta: {
                middleware: [
                  auth,
                  operator
                ],
                layout: 'AppLayoutOperator'
              }
            },
            {
                path: 'juridical-contracts',
                name: 'JuridicalContracts',
            component: () => import('@/pages/operator/JuridicalContracts'),
                meta: {
                    middleware: [
                        auth,
                        operator
                    ],
                    layout: 'AppLayoutOperator'
                }
            },
            {
                path: 'server-setting',
                name: 'ServerSetting',
                component: () => import('@/pages/operator/ServerSetting'),
                meta: {
                    middleware: [
                        auth,
                        operator
                    ],
                    layout: 'AppLayoutOperator'
                }
            },
        ]
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

const guard = (to, from, next) => {
    // check for valid auth token
    Vue.prototype.$axios.get('/token/check').then(() => {
      next();
    })
};


router.beforeEach((to, from, next) => {
    const loginRoutes = ['login', 'OperatorLogin', 'biometry', 'kdp', 'MobilePinCode', 'mobileBiometric', 'emailConfirm'];

    if (!loginRoutes.includes(to.name)) {
      guard(to, from, next);
    }

    if (!to.meta.middleware) {
        return next()
    }
    const store = Vue.prototype.$store;
    const middleware = to.meta.middleware
    const context = {
        to,
        from,
        next,
        store
    }
    const isAuthenticated = !!store?.getters?.['auth/isAuthenticated'];
    if (to.matched.some(record => record.meta.requiresAuth) && !isAuthenticated) {
      next('/login');
    } else {
      next();
    }
    return middleware[0]({
        ...context,
        next: middlewarePipeline(context, middleware, 1)
    })
})

export default router
